module.exports = __webpack_public_path__ + "img/appltCourse-img11.a0e19cda.png";